import AppHeader from "../../layout/AppHeader";
import CockpitBudgetPainel from '../../xpost/views/dashboard/CockpitBudgetPainel.vue'

const BudgetRoutes = [
  {
    path: "/cockpit/budget/import",
    name: "budget.import",
    components: {
      header: AppHeader,
      default: CockpitBudgetPainel,
    }
  },
]

export default BudgetRoutes;
